import Vue from 'vue';
import VueNotifyMessage from '@telexpress/vue-notify-message';

Vue.use(VueNotifyMessage);
